import React from 'react'
import styled from 'styled-components'

const HeaderBody = styled.div`
  text-align: left;
  padding-top: 2rem;
  padding-left: 2%;
  padding-right: 2%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-self: center;
  width: 100%;
  
  @media (max-width: 830px) {
    width: 95%;
  }
`

export default HeaderBody
